/* src/app/modules/concept/controlstock/controlstock.component.css */
/*# sourceMappingURL=controlstock.component.css.map */
